module.exports = __webpack_public_path__ + "img/form-twi.47ccc555.svg";